const packages = [
  {
    id: "morning",
    name: "Morning Safari",
    price: 150,
    variant: "gold",
    featured: true,
    location: "Dubai",
    rating: 4.6,
    reviewCount: 128,
    groupSize: 20,
    image:
      "https://images.unsplash.com/photo-1451337516015-6b6e9a44a8a3?auto=format&fit=crop&w=900&q=80",
    tagline: "A cool, quiet start to the dunes before the heat sets in.",
    features: [
      "Hotel pickup & drop-off",
      "45-minute dune bashing in a 4x4",
      "Morning refreshments",
      "Camera stop at the red dunes",
      "Small group (max 6 per vehicle)",
    ],
    duration: "3 hours",
    timeSlots: ["6:00 AM", "7:00 AM", "8:00 AM"],
  },
  {
    id: "basic",
    name: "Basic Safari",
    price: 200,
    variant: "orange",
    featured: false,
    location: "Dubai",
    rating: 4.8,
    reviewCount: 342,
    groupSize: 50,
    image:
      "https://images.unsplash.com/photo-1509316785289-025f5b846b35?auto=format&fit=crop&w=900&q=80",
    tagline: "Our most popular evening safari with dinner under the stars.",
    features: [
      "Hotel pickup & drop-off",
      "45-minute dune bashing in a 4x4",
      "Camel photo stop",
      "BBQ buffet dinner at desert camp",
      "Live tanoura & belly dance show",
    ],
    duration: "6 hours",
    timeSlots: ["3:00 PM", "3:30 PM", "4:00 PM"],
  },
  {
    id: "advanced",
    name: "Advanced Safari with 30 min quad bike ride",
    price: 280,
    variant: "navy",
    featured: false,
    location: "Dubai",
    rating: 4.4,
    reviewCount: 3,
    groupSize: 50,
    image:
      "https://images.unsplash.com/photo-1512100356356-de1b84283e18?auto=format&fit=crop&w=900&q=80",
    tagline: "Everything in Basic, plus adrenaline add-ons included.",
    features: [
      "Hotel pickup & drop-off",
      "60-minute dune bashing in a 4x4",
      "Quad bike ride (30 min)",
      "BBQ buffet dinner at desert camp",
      "Live entertainment & sheesha",
    ],
    duration: "10 days",
    timeSlots: ["3:00 PM", "3:30 PM", "4:00 PM"],
  },
  {
    id: "premium",
    name: "Premium Safari",
    price: 250,
    variant: "navy",
    featured: false,
    location: "Dubai",
    rating: 4.9,
    reviewCount: 96,
    groupSize: 15,
    image:
      "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=900&q=80",
    tagline: "The full VIP desert experience with premium seating & dining.",
    features: [
      "Private hotel pickup & drop-off",
      "60-minute dune bashing in a luxury 4x4",
      "VIP majlis seating at camp",
      "Premium buffet dinner + open drinks",
      "Falcon photo session & henna painting",
    ],
    duration: "7 hours",
    timeSlots: ["3:00 PM", "3:30 PM"],
  },
];

export default packages;
